// Import model.
import TableHeaderCellData, { TableHeaderCellDataParameters } from './TableHeaderCellData';

interface TableHeaderCellSortableDataParameters<TDataType> extends TableHeaderCellDataParameters<TDataType> {
    sortableDataValue?: (data: TDataType) => string | number;
}

class TableHeaderCellSortableData<TDataType> extends TableHeaderCellData<TDataType> {
    public sortableDataValue: ((data: TDataType) => string | number) | undefined;

    public constructor(params: TableHeaderCellSortableDataParameters<TDataType>) {
        super(params);
        this.sortableDataValue = params.sortableDataValue;
    }
}

export default TableHeaderCellSortableData;